import { useMemo } from 'react';
import { useGetReviewProfiles } from 'data/v3/reviewProfiles';
import { type ReviewProfileObject } from 'data/v3/data-contracts';

export type ReviewProfile = Pick<
  ReviewProfileObject,
  'id' | 'nickname' | 'googlePlaceId'
>;

export const useReviewProfiles = () => {
  const {
    data: reviewProfilesResponse,
    isLoading: isReviewProfilesLoading,
    error: isRevieProfileError,
    refetch: refetchReviewProfiles,
  } = useGetReviewProfiles(true);

  const isProfilesLoading = isReviewProfilesLoading;

  const reviewProfiles = useMemo(() => {
    return reviewProfilesResponse?.data || [];
  }, [reviewProfilesResponse?.data]);

  const defaultReviewProfile = reviewProfiles?.[0] || null;

  return {
    reviewProfiles,
    defaultReviewProfile,
    isReviewProfilesLoading: isProfilesLoading,
    isReviewProfileError: isRevieProfileError,
    refetchReviewProfiles,
    hasReviewProfiles: reviewProfiles.length > 0,
  };
};
